import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { isString } from 'lodash'
import { mediaQueries } from '@blazar-plugins/device'
import { TextSubHeading, TextCallout2 } from 'blocket-ui'
import { getFormattedPrice, getFormattedPriceWithoutVat } from 'utils/ad'

import arrowheadDiagonalRight from './arrowheadDiagonalRight.svg'

const Wrapper = styled(TextSubHeading)`
  color: #49b975;
  font-size: 15px;
  display: flex;
  align-items: flex-end;
  margin-right: 8px;

  @media ${mediaQueries.medium} {
    font-size: 17px;
    line-height: 20px;
  }
`

const styledPricesWrapper = { display: 'inline-block' }

const StyledPrice = styled.div`
  margin-right: 4px;
`

const StyledVatPrice = styled(TextCallout2)`
  color: #49b975;
  font-size: 12px;
  display: inline-block;

  @media ${mediaQueries.medium} {
    font-size: 15px;
  }
`

export const ArrowIcon = styled.div`
  display: inline-block;
  margin-left: 5px;
  background: center/contain no-repeat url(${arrowheadDiagonalRight});
  width: 12px;
  height: 12px;
`

const Price = ({ price, hideVat }) => {
  if (isString(price)) {
    return (
      <Wrapper>
        <span>{price}</span>
      </Wrapper>
    )
  }
  const formattedPrice = getFormattedPrice(price)
  const priceWithoutVat = getFormattedPriceWithoutVat(price)
  return (
    <Wrapper>
      <div>
        <span style={styledPricesWrapper}>
          <StyledPrice>{formattedPrice}</StyledPrice>
          {priceWithoutVat !== 0 && typeof priceWithoutVat !== 'undefined' && !hideVat && (
            <StyledVatPrice>{priceWithoutVat}</StyledVatPrice>
          )}
        </span>
        {price && price.priceLowered && <ArrowIcon />}
      </div>
    </Wrapper>
  )
}

Price.propTypes = {
  hideVat: PropTypes.bool,
  price: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      suffix: PropTypes.string,
      valueWithoutVat: PropTypes.number,
      priceLowered: PropTypes.bool,
      oldValue: PropTypes.number,
    }),
  ]),
}

export default Price
